/**
 * Action types.
 */
export const ADOBE_USER_AUTHENTICATED = 'adobe_user_authenticated';
export const ADOBE_USER_AUTHORIZED = 'adobe_user_authorized';
export const ADOBE_USER_UNAUTHORIZED = 'adobe_user_unauthorized';
export const BLOCKED_BY_PARENTS = 'blocked_by_parents';

/**
 * Initial module state.
 */
const initialState = {
  // The NULL state indicates that authentication status is unknown.
  authenticated: null,
  // The NULL state indicates that authorization status is unknown.
  authorized: null,
  parentalBlock: false,
  provider: 'none',
};

/**
 * Reducer function. Accepts a state and an action, and returns the modified
 * state depending on the action type. If no matching action types are found,
 * returns the unmodified state.
 *
 * @param {object} state - The state to modify or return.
 * @param {object} action - The action type to analyze.
 * @returns {object} - The new state value.
 */
export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADOBE_USER_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        provider: payload.mvpd,
      };

    case ADOBE_USER_AUTHORIZED:
      return {
        ...state,
        authorized: true,
      };

    case ADOBE_USER_UNAUTHORIZED:
      return {
        ...state,
        authorized: false,
      };

    case BLOCKED_BY_PARENTS:
      return {
        ...state,
        parentalBlock: true,
      };

    default:
      return state;
  }
}

/**
 * Fires when Adobe has authenticated a user with an MVPD provider.
 *
 * @param {String} mvpd Current MVPD provider.
 * @returns {{type: string, payload: object}}
 */
export function adobeUserAuthenticated(mvpd) {
  return {
    type: ADOBE_USER_AUTHENTICATED,
    payload: {
      mvpd,
    },
  };
}

/**
 * Fires when Adobe has authorized a user to view a resource with the MVPD provider.
 *
 * @returns {{type: string, payload: object}}
 */
export function adobeUserAuthorized() {
  return {
    type: ADOBE_USER_AUTHORIZED,
    payload: {},
  };
}

/**
 * Fires when Adobe has rejected a user from viewing a resource with the MVPD provider.
 *
 * @returns {{type: string, payload: object}}
 */
export function adobeUserUnauthorized() {
  return {
    type: ADOBE_USER_UNAUTHORIZED,
    payload: {},
  };
}

/**
 * Fires when the MVPD provider has said the resource does not match the
 * parental control settings for the user account.
 *
 * @returns {{type: string, payload: object}}
 */
export function tveBlockedByParentalControls() {
  return {
    type: BLOCKED_BY_PARENTS,
    payload: {},
  };
}
